<template>
    <v-ons-page>

        <ons-toolbar class="main-toolbar branded">
            <div class="left">
                <a v-on:click="$router.go(-1)">
                    <svg class="icon icon-back" aria-hidden="true"></svg>
                </a>
            </div>
            <div class="center brand-toobar">
                <div class="outlet-navbar">
                    <span class="outlet-store-name">{{ outlet ? outlet.store_display_name : '' }}</span>
                </div>
            </div>
            <div class="right">

            </div>
        </ons-toolbar>

        <div class="content">
            <v-ons-progress-bar v-if="show_loading" indeterminate></v-ons-progress-bar>

            <template v-if="outlet != null">
                <v-ons-tabbar position="auto"
                              class="branded"
                              v-bind:tabs="tabs"
                              v-bind:visible="true"
                              v-bind:index.sync="active_index">
                </v-ons-tabbar>
            </template>

        </div>

    </v-ons-page>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import OutletInfoComponent from './tabs/outlet_info'
import OpeningTimesComponent from './tabs/opening_times'
import LocationTabComponent from './tabs/location'

export default {

    props: [],

    components : {

    },

    created() {

    },

    mounted() {

        this.app.trackFbEvent(
            'ViewContent',
            {
                content_name: 'Info',
            }
        )

    },

    data () {
        return {
            app: this.$root.$data.app,
            active_index: 0,
            tabs: [
                {
                    label: 'Store Info',
                    page: OutletInfoComponent,
                    key: 'store_info',
                },
                {
                    label: 'Opening Times',
                    page: OpeningTimesComponent,
                    key: 'opening_times',
                },
                {
                    label: 'Location',
                    page: LocationTabComponent,
                    key: 'location',
                }
            ]
        }
    },

    methods : {

    },

    computed: {
        ...mapGetters([
            'outlet',
        ]),

        show_loading: function(){
            return this.outlet == null
        }
    },
}
</script>

<style scoped >

</style>


// WEBPACK FOOTER //
// src/js/components/outlets/outlet.vue